// @spec DHB-STR-030
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { ReportingPeriodsPage } from '@/features/datahub/periods/pages/ReportingPeriodsPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/settings/reporting-periods')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.reportingPeriods'),
  }),
  component: SettingsReportingPeriodsPage,
});

function SettingsReportingPeriodsPage() {
  return <ReportingPeriodsPage />;
}
